import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Row, Col, Card, CardBody, CardHeader, Button } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
import AssetTypeFilter from './assetTypeFilter';
import AssetOrganizationFilter from './assetOrganizationFilter';
import ControlFilterSwitch from '../common/controls/controlFilterSwitch';
import Icon from '../common/containers/icon';
import pagerFactory from '../common/pagingTable/pagerFactory';
import searchFactory from '../common/lookups/searchFactory';
import SearchInput from '../common/search/searchInput';
import tieredFilterEntity from '../common/lookups/tieredFilterEntity';
const AssetJobFilter = tieredFilterEntity('asset', 'jobFilterAsset', 'job');
const AssetJobPager = pagerFactory('jobFilterAsset');
const AssetJobSearch = searchFactory('jobFilterAsset');
const AssetStatusFilter = tieredFilterEntity('asset', 'assetStatus', 'assetStatus');
const getJobOptionName = option => _objectSpread(_objectSpread({}, option), {}, {
  name: option.jobNumber
});
const AssetsFilterPanel = _ref => {
  let _ref$filters = _ref.filters,
    filters = _ref$filters === void 0 ? {} : _ref$filters,
    onFilter = _ref.onFilter,
    onFilterClear = _ref.onFilterClear,
    onSearch = _ref.onSearch,
    onSearchClear = _ref.onSearchClear;
  let controlFilterSwitch;

  // needed for the issue items control.
  const handleBack = () => {
    controlFilterSwitch.controlSwitch.switchControl();
  };
  const assetOrgControl = /*#__PURE__*/React.createElement(AssetOrganizationFilter, {
    filters: filters,
    onFilter: onFilter,
    onBack: handleBack
  });
  const assetTypeControl = /*#__PURE__*/React.createElement(AssetTypeFilter, {
    filters: filters,
    onFilter: onFilter,
    onBack: handleBack
  });
  const assetJobControl = /*#__PURE__*/React.createElement(AssetJobFilter, {
    label: "Job",
    getOptionName: getJobOptionName,
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(AssetJobSearch, null), /*#__PURE__*/React.createElement(AssetJobPager, null));
  const assetStatusControl = /*#__PURE__*/React.createElement(AssetStatusFilter, {
    label: "Status",
    onBack: handleBack
  });
  const filterControls = [{
    label: 'Organizations',
    filterName: ['organization', 'facility', 'facilityGroup', 'facilityGroupArea'],
    control: assetOrgControl,
    filters
  }, {
    label: 'Category / Type',
    filterName: ['assetCategoryName', 'assetType'],
    control: assetTypeControl,
    filters
  }, {
    label: 'Job',
    filterName: 'job',
    control: assetJobControl,
    filters
  }, {
    label: 'Status',
    filterName: 'assetStatus',
    control: assetStatusControl,
    filters
  }];
  controlFilterSwitch = /*#__PURE__*/React.createElement(ControlFilterSwitch, {
    filterControls: filterControls,
    ref: input => {
      controlFilterSwitch = input;
    }
  });
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 8
  }, /*#__PURE__*/React.createElement("h3", {
    className: "t-ac-sidebar-title"
  }, "Filter")), /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: onFilterClear,
    className: "float-md-right t-ac-filter-clear"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "times-circle",
    weight: "far"
  }), " Clear")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(SearchInput, {
    type: "text",
    placeholder: "AssetID or Alias",
    text: filters.text,
    onChange: onSearch,
    onClear: onSearchClear
  }), controlFilterSwitch));
};
AssetsFilterPanel.propTypes = {
  onFilter: PropTypes.func.isRequired,
  onFilterClear: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onSearchClear: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    text: PropTypes.string
  })
};
export default AssetsFilterPanel;